import { nameBuilderMapper } from '../constants';
import { TYPES } from '../../constants';
import { mapper } from '../../transformer';

const getNameByType = (type, urlParams) => {
    if (type === TYPES.NESTED_SUB_CATEGORY) {
        return nameBuilderMapper[type](urlParams.id, urlParams.subCategoryId);

    } else {
        return nameBuilderMapper[type](urlParams.id);
    }

};

export const getItemLink = (type, urlParams, source) => mapper[type] ? mapper[type](urlParams, source) : '';
export const getItemName = (alias, type, urlParams) =>
    alias || (nameBuilderMapper[type] ? getNameByType(type, urlParams) : '');